import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from 'src/app/@shared/services/config.service';
import { DefinitionType } from '../domain/enums/definition-type.enum';
import { DefinitionList } from '../domain/interfaces/definition.interface';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class DefinitionsApiService extends BaseApiService {
  constructor(configService: ConfigService, httpClient: HttpClient) {
    super(configService, httpClient);
  }

  // POST /api/gui/v1.0/definitions
  loadDefinitions(): Observable<DefinitionList[]> {
    const apiUrl = this.parkbaseBl9BaseUrl + '/definitions';
    const body = {
      types: [
        DefinitionType.TerminalTypes,
        DefinitionType.ManualCorrectionReasons,
        DefinitionType.ManualGrantPassageReasons,
        DefinitionType.NotificationLevels,
        DefinitionType.NotificationTypes,
      ],
    };
    return this.http.post<DefinitionList[]>(apiUrl, body, { headers: this.setHeaders() }).pipe(
      tap((data) => {
        this.parkbaseStorageService.storeDefinitionLists(data);
      })
    );
  }

  // GET /api/gui/v1.0/definitions/{id}
  loadDefinitionsById(): void {}

  // POST /api/gui/v1.0/definitions/{id}/search
  searchDefinitionsById(): void {}
}
